import { AxiosCustomRequestType } from '../../models/utils/axios.type';
import { call } from '../core.service';

type QiveReceivedNFeResponseType = {
  data: {
    access_key: string;
    xml: string;
  }[];
  page?: {
    next?: string | null;
    previous?: string | null;
  };
  count?: number;
};

type QiveReceivedNFeType = {
  accessKey: string;
  xml: string;
};

const qiveEndpoint = '/v1/qive';

const decodeBase64ToXml = (value: string): string => {
  const binary = window.atob(value);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder('utf-8').decode(bytes);
};

const formatDate = (value: Date): string => {
  const year = value.getFullYear();
  const month = `${value.getMonth() + 1}`.padStart(2, '0');
  const day = `${value.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const listarNFesRecebidasPorPeriodo = async (
  dataInicial: Date,
  dataFinal: Date
): Promise<QiveReceivedNFeType[]> => {
  // let totalItems = 0;
  const dataFinalAjustada = new Date(dataFinal);
  dataFinalAjustada.setDate(dataFinalAjustada.getDate() + 1);

  const loadPage = async (cursor?: string): Promise<QiveReceivedNFeType[]> => {
    const limit = 50;
    const request: AxiosCustomRequestType = {
      method: 'GET',
      url: qiveEndpoint,
      params: {
        dataInicial: formatDate(dataInicial),
        dataFinal: formatDate(dataFinalAjustada),
        limit,
        cursor,
      },
    };

    const response = (await call(request))?.data?.data as QiveReceivedNFeResponseType;

    const currentItems = (response?.data || []).map((item) => ({
      accessKey: item.access_key,
      xml: decodeBase64ToXml(item.xml),
    }));

    const nextCursor = response?.page?.next?.split('cursor=')?.[1]?.split('&')?.[0];
    if (response.count === 0) {
      return currentItems;
    }
    const nextItems = await loadPage(nextCursor);
    return currentItems.concat(nextItems);

    // if ((response.count || 0) < limit) {
    //   return currentItems;
    // }

    // totalItems += currentItems.length;
    // const nextItems = await loadPage(totalItems.toString());
    // return currentItems.concat(nextItems);
  };

  return loadPage();
};

// eslint-disable-next-line import/prefer-default-export
export default { listarNFesRecebidasPorPeriodo };
